import React, { useState, useEffect, useContext } from "react";
import { Form, Table, Pagination, Dropdown } from "react-bootstrap";
import AuthContext from "../../context/auth/authContext";

import Header from "../../components/Layout/Header";
import Sidebar from "../../components/Layout/Sidebar";
import Main from "../../components/Layout/Main";
import SweetAlertWrapper from "../../components/Layout/sweetAlert"
import RolePermissionsModal from "./rolePermissions";
import AssignedUsersModal from "./roleUsers";

import AssignRoleModal from "./assignRole";
import UnasignRoleModal from "./unAssign";
import { set } from "date-fns";

const ListRoles = () => {
    const authContext = useContext(AuthContext);
    const { roles, getRoles, listRolePermissions, notification, clear_notifications } = authContext;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rolesPerPage] = useState(15); // Number of roles per page

    const [showModal, setShowModal] = useState(false);
    const [showRolePermissionsModal, setShowRolePermissionsModal] = useState(false);
    const [showAssignedUsersModal, setShowAssignedUsersModal] = useState(false);
    const [showUnassignModal, setShowUnassignModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");

    const handleClose = () => {
        setShowModal(false);
        setShowUnassignModal(false);
        setShowRolePermissionsModal(false);
        setShowAssignedUsersModal(false);
        setSelectedRole("");
    };

    const handleShow = (roleId) => {
        setSelectedRole(roleId);
        setShowModal(true);
    };

    const handleShowRolePermissions = () => {
        setShowRolePermissionsModal(true);
    }

    const handleShowAssignedUsersModal = (roleId) => {
        setSelectedRole(roleId);
        setShowAssignedUsersModal(true);
    }

    const handleUnassignShow = (roleId) => {
        setSelectedRole(roleId);
        setShowUnassignModal(true);
    };


    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ text: "", type: "" });

    const handleConfirm = () => {
        clear_notifications();
        setShowAlert(false);
    };

    useEffect(() => {
        if (notification) {
            setAlertMessage({
                text: notification.text,
                type: notification.type,
            });
            setShowAlert(true);
        }
    }, [notification]);

    const indexOfLastRole = currentPage * rolesPerPage;
    const indexOfFirstRole = indexOfLastRole - rolesPerPage;
    const currentRoles = roles.slice(indexOfFirstRole, indexOfLastRole);

    const filteredRoles = currentRoles.filter((role) =>
        role.roleName.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    useEffect(() => {
        getRoles();
    }, []);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to the first page after search
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div>
            <Header />
            <Sidebar page="roles" />
            <Main>
                { }
                {showModal && selectedRole &&
                    <

                        AssignRoleModal
                        show={showModal}
                        handleClose={handleClose}
                        role={selectedRole}
                    />
                }

                {showUnassignModal && selectedRole &&
                    <UnasignRoleModal
                        show={showUnassignModal}
                        handleClose={handleClose}
                        role={selectedRole}
                    />
                }

                {
                    showRolePermissionsModal
                    && selectedRole &&
                    <RolePermissionsModal
                        show={showRolePermissionsModal}
                        handleClose={handleClose}
                        role={selectedRole}
                    />
                }


                {setShowAssignedUsersModal && selectedRole &&
                    <AssignedUsersModal
                        show={showAssignedUsersModal}
                        handleClose={handleClose}
                        roleId={selectedRole.roleCode}
                    />
                }

                <SweetAlertWrapper
                    show={showAlert}
                    title="Notification"
                    message={alertMessage.text}
                    onConfirm={handleConfirm}
                    confirmBtnText="OK"
                    type={alertMessage.type || "info"}
                />

                <Form.Control
                    type="text"
                    placeholder="Search roles..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="mb-3"
                />

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Role ID</th>
                            <th>Role Name</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRoles.length > 0 ? (
                            filteredRoles.map((role) => (
                                <tr key={role.roleCode}>
                                    <td>{role.roleCode}</td>
                                    <td>{role.roleName}</td>
                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="secondary"
                                                id="dropdown-basic"
                                            >
                                                Actions
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() =>
                                                        handleShow(role)
                                                    }
                                                >
                                                    Assign Role to User
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setSelectedRole(role);
                                                        handleShowRolePermissions();
                                                    }}
                                                >
                                                    View Role Permissions

                                                </Dropdown.Item>


                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setSelectedRole(role);
                                                        handleShowAssignedUsersModal(role.roleCode);
                                                    }}
                                                >
                                                    Role Users
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                    onClick={() =>{
                                                        setSelectedRole(role);
                                                        handleUnassignShow(role)}
                                                    }
                                                >
                                                    Unassign Role from User
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2">No roles found</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                <Pagination className="justify-content-center">
                    <Pagination.Prev
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    />
                    {[...Array(Math.ceil(roles.length / rolesPerPage))].map(
                        (_, i) => (
                            <Pagination.Item
                                key={i + 1}
                                active={i + 1 === currentPage}
                                onClick={() => paginate(i + 1)}
                            >
                                {i + 1}
                            </Pagination.Item>
                        ),
                    )}
                    <Pagination.Next
                        onClick={() => paginate(currentPage + 1)}
                        disabled={
                            currentPage ===
                            Math.ceil(roles.length / rolesPerPage)
                        }
                    />
                </Pagination>
            </Main>
        </div>
    );
};

export default ListRoles;
